import { render } from "./Why.vue?vue&type=template&id=1b723bf0&scoped=true"
import script from "./Why.vue?vue&type=script&lang=js"
export * from "./Why.vue?vue&type=script&lang=js"

import "./Why.vue?vue&type=style&index=0&id=1b723bf0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b723bf0"

export default script